import { FC, useMemo } from 'react'
import { Field, reduxForm } from 'redux-form'
import * as styles from 'styles/molecules/forms/Form.css'
import schema from 'schemas/passwordResetFormSchema'
import { asyncValidator } from 'helpers/schemaHelpers'
import { FORM_PASSWORD_RESET } from 'constants/forms'
import Button from 'components/features/pfm/Button/Button'
import { ReduxFormProps } from 'interfaces/component'
import TextFieldWrapped from 'components/atoms/inputs/TextFieldWrapped'
import { getSaveButtonFormProps, shouldAsyncValidate } from 'helpers/formHelpers'
import PasswordFieldContainer from 'components/features/pfm/PasswordField/PasswordFieldContainer'
import { FIELD_CONFIRM_PASSWORD_PROPS, FIELD_EMAIL_PROPS } from 'constants/fields'
import LoginLink from 'components/atoms/LoginLink'
import TextButton from 'components/atoms/buttons/TextButton'
import { VerificationCodeHintBox } from 'components/features/pfm/VerificationCodeHintBox/VerificationCodeHintBox'

type PasswordResetFormProps = ReduxFormProps

const PasswordResetFormComponent: FC<PasswordResetFormProps> = (props) => {
  const { handleSubmit } = props

  const emailFieldProps = useMemo(() => ({
    ...FIELD_EMAIL_PROPS,
    disabled: true,
  }), [])

  const codeFieldProps = useMemo(() => ({
    label: 'Code',
    type: 'text',
    autoFocus: true,
  }), [])

  return (
    <div>
      <form className={ styles.formFullWidth } onSubmit={ handleSubmit }>
        <ul>
          <li className={ styles.item }>
            <Field
              name='email'
              props={ emailFieldProps }
              component={ TextFieldWrapped }
            />
          </li>
          <li className={ styles.item }>
            <VerificationCodeHintBox />
          </li>
          <li className={ styles.item }>
            <Field
              name='code'
              props={ codeFieldProps }
              component={ TextFieldWrapped }
            />
          </li>
          <li className={ styles.item }>
            <PasswordFieldContainer label='New Password' />
          </li>
          <li className={ styles.item }>
            <Field
              name='password_confirm'
              component={ TextFieldWrapped }
              props={ FIELD_CONFIRM_PASSWORD_PROPS }
            />
          </li>
          <li className={ styles.submitItem }>
            <Button { ...getSaveButtonFormProps(props) } submit fullWidth>
              Update password
            </Button>
          </li>
          <li className={ styles.cancelLinkWrapper }>
            <LoginLink>
              <TextButton>Cancel</TextButton>
            </LoginLink>
          </li>
        </ul>
      </form>
    </div>
  )
}

export const PasswordResetForm = reduxForm({
  form: FORM_PASSWORD_RESET,
  asyncValidate: asyncValidator(schema),
  shouldAsyncValidate,
})(PasswordResetFormComponent)
